module.exports = __webpack_public_path__ + "static/img/S4.cef8250c.png";